import * as cookie from 'cookie';
import { Injectable } from '@angular/core';

@Injectable()
export class ClientCookie {

  get(key) {
    const cookieStr = cookie.parse(document.cookie);
    return cookieStr[key];
  }

  all() {
    return cookie.parse(document.cookie);
  }

  remove(key) {
    document.cookie = cookie.serialize(key, '', {
      expires: new Date('1980-01-01'),
      path: '/',
      httpOnly: true,
      secure: true
    });
    return true;
  }
}

export const clientCookieProvider = {
  provide: ClientCookie,
  useClass: ClientCookie,
};